import React from 'react';
import { useSelector } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import { checkForFullScreen } from '@awp/helpers/navigation';
import TopHeader from './TopHeader';
import { selectFullScreen } from '@stores/fullScreenSlice';
import { selectCurrentUser } from '@stores/usersSlice';
import HeaderMenu from '@components/Navigation/HeaderMenu';

const Header = ({ inMaintenance, inEntireMaintenance = false, isBarExpanded, setIsBarExpanded }) => {
  const fullScreen = useSelector(selectFullScreen);
  const currentUser = useSelector(selectCurrentUser);

  const expandedClick = () => {
    setIsBarExpanded(isBarExpanded ? false : 'expanded');
  };

  if (inEntireMaintenance) {
    return (
      <>
        <TopHeader expandedClick={expandedClick} isBarExpanded={isBarExpanded} />
        <Alert
          variant="warning"
          className="mb-0"
          onClose={(status, event) => {
            event.currentTarget.parentNode.remove();
          }}
        >
          <Container className="text-center">We are currently undergoing maintenance, please try again.</Container>
        </Alert>
      </>
    );
  }

  const isFullScreen = checkForFullScreen(fullScreen.enabled);

  return (
    <>
      {isFullScreen ? <></> : <TopHeader expandedClick={expandedClick} isBarExpanded={isBarExpanded} />}
      {inMaintenance && (
        <Alert
          variant="warning"
          className="mb-0"
          onClose={(status, event) => {
            event.currentTarget.parentNode.remove();
          }}
          dismissible
        >
          <Container className="text-center">
            We are currently undergoing maintenance, but offline features are still available.
          </Container>
        </Alert>
      )}
      {!isFullScreen && <HeaderMenu expandedClick={expandedClick} isBarExpanded={isBarExpanded} />}
    </>
  );
};

export default Header;
